import { ProLightXmark } from '@nexelem/icons/ProLightXmark';
import { IconButton } from '@nexelem/components';
import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';
import { useModalContext } from './ModalContext';
import { useIsJumbo } from '@nexelem/utils';

type ModalHeaderProps = {
  withCloseButton?: boolean;
  children?: ReactNode;
  Actions?: FC;
  StartIcon?: FC;
  EndIcon?: FC;
  iconGap?: number;
  className?: string;
};

export const ModalHeader = ({
  withCloseButton = false,
  children,
  StartIcon,
  EndIcon,
  Actions,
  iconGap = 0,
  className,
}: ModalHeaderProps) => {
  const { onClose } = useModalContext();
  const isJumbo = useIsJumbo();
  return (
    <div
      className={clsx(
        isJumbo ? 'pt-5 pr-4 pl-8' : 'pt-3.5 pr-2 pl-6',
        'flex items-center justify-between pb-2.5',
        className,
      )}
    >
      <div className="flex w-full items-center" style={{ gap: iconGap }}>
        {StartIcon && <StartIcon />}
        <h2 className={clsx(isJumbo ? 'text-t32' : 'text-t24-sb', 'w-full')}>{children}</h2>
        {EndIcon && <EndIcon />}
      </div>
      {withCloseButton && (
        <div className="flex gap-1">
          {Actions && <Actions />}
          <IconButton Icon={ProLightXmark} size={isJumbo ? 'large' : 'small'} onClick={onClose} />
        </div>
      )}
    </div>
  );
};
